import React from 'react'
import { connect } from 'react-redux'
import OkresSprawozdania from '../../components/DaneOrganizacyjne/OkresSprawozdania'
import InfoPanel from '../../components/InfoPanel'
import WykazOkresowSprawozdania from '../../components/OkresSprawozdawczy/WykazOkresowSprawozdania'
import WykazOkresowSprawozdaniaR2 from '../../components/OkresSprawozdawczy/WykazOkresowSprawozdaniaR2'
import { dateFromCalendar } from '../../lib/formatDateHandler'
import * as actions from '../../store/actions'
import MainStyle from '../../styles/MainStyle'

function OkresSprawozdawczy({
  onSetSectionDataArray,
  onSetSectionData,
  onSetDates,
  sectionList,
  validityErrors,
  dataWersjiOd,
  dataWersjiDo,
  dataSporzadzenia,
  poczatekOkresuOd,
  poczatekOkresuDo,
  poczatekOkresu,
  koniecOkresu,
}) {
  function zauktualizujDaty(dataOd, dataDo) {
    sectionList.forEach((section, index) => {
      if (section.TypSekcji === 'WykazOkresowSprawozdania') {
        if (
          section.Dane &&
          section.Dane.Pozycje &&
          section.Dane.Pozycje.length !== 0
        )
          section.Dane.Pozycje.forEach((x, index) => {
            onSetSectionDataArray(dateFromCalendar(dataOd), index, 1, 'DataOd')
            onSetSectionDataArray(dateFromCalendar(dataDo), index, 1, 'DataDo')
          })
      } else if (section.TypSekcji === 'WykazOkresowSprawozdania_v1_2') {
        onSetSectionData('DataOd', dateFromCalendar(dataOd), index)
        onSetSectionData('DataDo', dateFromCalendar(dataDo), index)
      }
    })
  }

  return (
    <MainStyle>
      <InfoPanel
        canExpand={false}
        rolledContent={
          <div>
            W tym miejscu należy wskazać okres objęty skonsolidowanym
            sprawozdaniem finansowym oraz datę sporządzenia sprawozdania. Należy
            też podać wykaz lat obrotowych lub okresów objętych sprawozdaniem
            finansowym jednostek powiązanych, jeżeli są one różne od okresu
            objętego skonsolidowanym sprawozdaniem finansowym..
          </div>
        }
      />
      {sectionList.map((data, sIndex) => {
        switch (data.TypSekcji) {
          case 'OkresSprawozdaniaSkrocona':
          case 'OkresSprawozdaniaSkrocona_r2':
            return (
              <OkresSprawozdania
                key={sIndex}
                data={data.Dane}
                dataWersjiOd={dataWersjiOd}
                dataWersjiDo={dataWersjiDo}
                poczatekOkresuOd={poczatekOkresuOd}
                poczatekOkresuDo={poczatekOkresuDo}
                poczatekOkresu={poczatekOkresu}
                koniecOkresu={koniecOkresu}
                dataSporzadzenia={dataSporzadzenia}
                errors={validityErrors.filter(
                  (value) => value.TypSekcji === data.TypSekcji,
                )}
                onSetSectionData={(name, value) =>
                  onSetSectionData(name, value, sIndex)
                }
                onSetDates={(dataOd, dataDo) => {
                  onSetDates(dataOd, dataDo)
                  zauktualizujDaty(dataOd, dataDo)
                }}
              />
            )
          case 'WykazOkresowSprawozdania':
          case 'WykazOkresowSprawozdania_v1_2':
            return (
              <WykazOkresowSprawozdania
                key={sIndex}
                sIndex={sIndex}
                data={data.Dane}
                validityErrors={validityErrors.filter(
                  (value) => value.TypSekcji === data.TypSekcji,
                )}
                onSetSectionDataArray={(v, i, n) =>
                  onSetSectionDataArray(v, i, sIndex, n)
                }
              />
            )
          case 'WykazOkresowSprawozdania_r2':
            return (
              <WykazOkresowSprawozdaniaR2
                key={sIndex}
                sIndex={sIndex}
                data={data.Dane}
                validityErrors={validityErrors.filter(
                  (value) => value.TypSekcji === data.TypSekcji,
                )}
                onSetSectionDataArray={(v, i, n) =>
                  onSetSectionDataArray(v, i, sIndex, n)
                }
              />
            )
          default:
            return null
        }
      })}
    </MainStyle>
  )
}

const mapStateToProps = (state) => ({
  validityErrors: state.sprawozdanie.validityErrors
    ? state.sprawozdanie.validityErrors
    : [],
  dataWersjiOd: state.sprawozdanie.header.DataWersjiOd,
  dataWersjiDo: state.sprawozdanie.header.DataWersjiDo,
  poczatekOkresuOd: state.sprawozdanie.header.PoczatekOkresuOd,
  poczatekOkresuDo: state.sprawozdanie.header.PoczatekOkresuDo,
  dataSporzadzenia: state.sprawozdanie.dataSporzadzenia,
  poczatekOkresu: state.sprawozdanie.poczatekOkresu,
  koniecOkresu: state.sprawozdanie.koniecOkresu,
})

const mapDispatchToProps = (dispatch) => ({
  onSetSectionDataArray: (v, index, sIndex, name) => {
    dispatch(actions.setSectionDataArray(v, index, sIndex, name))
  },
  onSetSectionData: (name, value, index) => {
    dispatch(actions.setSectionData(name, value, index))
  },
  onSetDates: (dateFrom, dateTo) => {
    dispatch(actions.setDates(dateFrom, dateTo))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(OkresSprawozdawczy)
